// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: portal/category_profile.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Category, CategoryCollection } from "../category_profile/category_profile";
import { Timestamp } from "../google/protobuf/timestamp";
import {
  Category as Category1,
  CategoryChange,
  CategoryCollectionChange,
  PlantProfile,
} from "../robot_syncer/plant_profile";
import { PaginationResponse } from "./pagination";

export const protobufPackage = "carbon.portal.category_profile";

export interface Metadata {
  updatedAt?: number | undefined;
}

/** @deprecated */
export interface SavedCategoryCollection {
  profile: CategoryCollection | undefined;
  metadata: Metadata | undefined;
}

/** @deprecated */
export interface SavedCategory {
  profile: Category | undefined;
  metadata: Metadata | undefined;
}

/** @deprecated */
export interface SavedExpandedCategoryCollection {
  profile: SavedCategoryCollection | undefined;
  categories: SavedCategory[];
}

/** @deprecated */
export interface UnsavedExpandedCategoryCollection {
  profile: CategoryCollection | undefined;
  categories: Category[];
}

export interface PlantProfileChanges {
  categories: CategoryChange[];
  collection: CategoryCollectionChange | undefined;
}

export interface DisplayUser {
  /** ideally auth0 id, but can be robot name */
  userId: string;
  displayName: string;
  picture?: string | undefined;
  isInternal: boolean;
}

/** extends robot_syncer.plant_profile.SavedVersionMetadata but adds user info */
export interface SavedVersionMetadata {
  /** uuid */
  versionId: string;
  user:
    | DisplayUser
    | undefined;
  /** the time that the client recorded the change */
  clientVersionCreateTime:
    | string
    | undefined;
  /** nullable version uuid - the version the client knew about when */
  parentVersionId?:
    | string
    | undefined;
  /** creating this version */
  revertVersionId?:
    | string
    | undefined;
  /** nullable - the time that the client recorded deletion - will always */
  clientDeleteTime?:
    | string
    | undefined;
  /** be set if deleted_by is set -- db or client? */
  deletedBy?:
    | string
    | undefined;
  /** when the version was activated */
  activeTime?: string | undefined;
}

export interface ListCategoryCollectionHistoryResponse {
  pagination: PaginationResponse | undefined;
  versions: SavedVersionMetadata[];
}

export interface ListCategoryHistoryResponse {
  pagination: PaginationResponse | undefined;
  versions: SavedVersionMetadata[];
}

export interface ProfileListRequest {
  limit?: number | undefined;
  olderCursor?: string | undefined;
  search?: string | undefined;
  inLibrary?: boolean | undefined;
  carbon?: boolean | undefined;
  customerUuid?: string | undefined;
  includeCustomCategories?: boolean | undefined;
}

export interface ListCategoriesResponse {
  pagination: PaginationResponse | undefined;
  categories: SavedLibraryCategory[];
}

/** extends robot_syncer.plant_profile.LibraryMetadata to add user info */
export interface SavedLibraryMetadata {
  addedTime: string | undefined;
  addedBy: DisplayUser | undefined;
}

/** extends robot_syncer.plant_profile.SavedCategory to add user info */
export interface SavedLibraryCategory {
  metadata: SavedVersionMetadata | undefined;
  category: Category1 | undefined;
  libraryMetadata?: SavedLibraryMetadata | undefined;
}

/** extends robot_syncer.plant_profile.SavedPlantProfile to add user info */
export interface SavedPlantProfile {
  metadata: SavedVersionMetadata | undefined;
  profile: PlantProfile | undefined;
}

function createBaseMetadata(): Metadata {
  return { updatedAt: undefined };
}

export const Metadata: MessageFns<Metadata> = {
  encode(message: Metadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.updatedAt !== undefined) {
      writer.uint32(48).int64(message.updatedAt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Metadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.updatedAt = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Metadata {
    return {
      updatedAt: isSet(object.updatedAt)
        ? globalThis.Number(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.Number(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: Metadata): unknown {
    const obj: any = {};
    if (message.updatedAt !== undefined) {
      obj.updatedAt = Math.round(message.updatedAt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Metadata>, I>>(base?: I): Metadata {
    return Metadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Metadata>, I>>(object: I): Metadata {
    const message = createBaseMetadata();
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseSavedCategoryCollection(): SavedCategoryCollection {
  return { profile: undefined, metadata: undefined };
}

export const SavedCategoryCollection: MessageFns<SavedCategoryCollection> = {
  encode(message: SavedCategoryCollection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.profile !== undefined) {
      CategoryCollection.encode(message.profile, writer.uint32(10).fork()).join();
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SavedCategoryCollection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSavedCategoryCollection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.profile = CategoryCollection.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SavedCategoryCollection {
    return {
      profile: isSet(object.profile) ? CategoryCollection.fromJSON(object.profile) : undefined,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: SavedCategoryCollection): unknown {
    const obj: any = {};
    if (message.profile !== undefined) {
      obj.profile = CategoryCollection.toJSON(message.profile);
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SavedCategoryCollection>, I>>(base?: I): SavedCategoryCollection {
    return SavedCategoryCollection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SavedCategoryCollection>, I>>(object: I): SavedCategoryCollection {
    const message = createBaseSavedCategoryCollection();
    message.profile = (object.profile !== undefined && object.profile !== null)
      ? CategoryCollection.fromPartial(object.profile)
      : undefined;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseSavedCategory(): SavedCategory {
  return { profile: undefined, metadata: undefined };
}

export const SavedCategory: MessageFns<SavedCategory> = {
  encode(message: SavedCategory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.profile !== undefined) {
      Category.encode(message.profile, writer.uint32(10).fork()).join();
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SavedCategory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSavedCategory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.profile = Category.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SavedCategory {
    return {
      profile: isSet(object.profile) ? Category.fromJSON(object.profile) : undefined,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: SavedCategory): unknown {
    const obj: any = {};
    if (message.profile !== undefined) {
      obj.profile = Category.toJSON(message.profile);
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SavedCategory>, I>>(base?: I): SavedCategory {
    return SavedCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SavedCategory>, I>>(object: I): SavedCategory {
    const message = createBaseSavedCategory();
    message.profile = (object.profile !== undefined && object.profile !== null)
      ? Category.fromPartial(object.profile)
      : undefined;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseSavedExpandedCategoryCollection(): SavedExpandedCategoryCollection {
  return { profile: undefined, categories: [] };
}

export const SavedExpandedCategoryCollection: MessageFns<SavedExpandedCategoryCollection> = {
  encode(message: SavedExpandedCategoryCollection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.profile !== undefined) {
      SavedCategoryCollection.encode(message.profile, writer.uint32(10).fork()).join();
    }
    for (const v of message.categories) {
      SavedCategory.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SavedExpandedCategoryCollection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSavedExpandedCategoryCollection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.profile = SavedCategoryCollection.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.categories.push(SavedCategory.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SavedExpandedCategoryCollection {
    return {
      profile: isSet(object.profile) ? SavedCategoryCollection.fromJSON(object.profile) : undefined,
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => SavedCategory.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SavedExpandedCategoryCollection): unknown {
    const obj: any = {};
    if (message.profile !== undefined) {
      obj.profile = SavedCategoryCollection.toJSON(message.profile);
    }
    if (message.categories?.length) {
      obj.categories = message.categories.map((e) => SavedCategory.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SavedExpandedCategoryCollection>, I>>(base?: I): SavedExpandedCategoryCollection {
    return SavedExpandedCategoryCollection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SavedExpandedCategoryCollection>, I>>(
    object: I,
  ): SavedExpandedCategoryCollection {
    const message = createBaseSavedExpandedCategoryCollection();
    message.profile = (object.profile !== undefined && object.profile !== null)
      ? SavedCategoryCollection.fromPartial(object.profile)
      : undefined;
    message.categories = object.categories?.map((e) => SavedCategory.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUnsavedExpandedCategoryCollection(): UnsavedExpandedCategoryCollection {
  return { profile: undefined, categories: [] };
}

export const UnsavedExpandedCategoryCollection: MessageFns<UnsavedExpandedCategoryCollection> = {
  encode(message: UnsavedExpandedCategoryCollection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.profile !== undefined) {
      CategoryCollection.encode(message.profile, writer.uint32(10).fork()).join();
    }
    for (const v of message.categories) {
      Category.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnsavedExpandedCategoryCollection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnsavedExpandedCategoryCollection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.profile = CategoryCollection.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.categories.push(Category.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnsavedExpandedCategoryCollection {
    return {
      profile: isSet(object.profile) ? CategoryCollection.fromJSON(object.profile) : undefined,
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => Category.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UnsavedExpandedCategoryCollection): unknown {
    const obj: any = {};
    if (message.profile !== undefined) {
      obj.profile = CategoryCollection.toJSON(message.profile);
    }
    if (message.categories?.length) {
      obj.categories = message.categories.map((e) => Category.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnsavedExpandedCategoryCollection>, I>>(
    base?: I,
  ): UnsavedExpandedCategoryCollection {
    return UnsavedExpandedCategoryCollection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnsavedExpandedCategoryCollection>, I>>(
    object: I,
  ): UnsavedExpandedCategoryCollection {
    const message = createBaseUnsavedExpandedCategoryCollection();
    message.profile = (object.profile !== undefined && object.profile !== null)
      ? CategoryCollection.fromPartial(object.profile)
      : undefined;
    message.categories = object.categories?.map((e) => Category.fromPartial(e)) || [];
    return message;
  },
};

function createBasePlantProfileChanges(): PlantProfileChanges {
  return { categories: [], collection: undefined };
}

export const PlantProfileChanges: MessageFns<PlantProfileChanges> = {
  encode(message: PlantProfileChanges, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.categories) {
      CategoryChange.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.collection !== undefined) {
      CategoryCollectionChange.encode(message.collection, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlantProfileChanges {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlantProfileChanges();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.categories.push(CategoryChange.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.collection = CategoryCollectionChange.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlantProfileChanges {
    return {
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => CategoryChange.fromJSON(e))
        : [],
      collection: isSet(object.collection) ? CategoryCollectionChange.fromJSON(object.collection) : undefined,
    };
  },

  toJSON(message: PlantProfileChanges): unknown {
    const obj: any = {};
    if (message.categories?.length) {
      obj.categories = message.categories.map((e) => CategoryChange.toJSON(e));
    }
    if (message.collection !== undefined) {
      obj.collection = CategoryCollectionChange.toJSON(message.collection);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlantProfileChanges>, I>>(base?: I): PlantProfileChanges {
    return PlantProfileChanges.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlantProfileChanges>, I>>(object: I): PlantProfileChanges {
    const message = createBasePlantProfileChanges();
    message.categories = object.categories?.map((e) => CategoryChange.fromPartial(e)) || [];
    message.collection = (object.collection !== undefined && object.collection !== null)
      ? CategoryCollectionChange.fromPartial(object.collection)
      : undefined;
    return message;
  },
};

function createBaseDisplayUser(): DisplayUser {
  return { userId: "", displayName: "", picture: undefined, isInternal: false };
}

export const DisplayUser: MessageFns<DisplayUser> = {
  encode(message: DisplayUser, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    if (message.picture !== undefined) {
      writer.uint32(26).string(message.picture);
    }
    if (message.isInternal !== false) {
      writer.uint32(32).bool(message.isInternal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DisplayUser {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisplayUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.picture = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isInternal = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DisplayUser {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      displayName: isSet(object.displayName)
        ? globalThis.String(object.displayName)
        : isSet(object.display_name)
        ? globalThis.String(object.display_name)
        : "",
      picture: isSet(object.picture) ? globalThis.String(object.picture) : undefined,
      isInternal: isSet(object.isInternal)
        ? globalThis.Boolean(object.isInternal)
        : isSet(object.is_internal)
        ? globalThis.Boolean(object.is_internal)
        : false,
    };
  },

  toJSON(message: DisplayUser): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.picture !== undefined) {
      obj.picture = message.picture;
    }
    if (message.isInternal !== false) {
      obj.isInternal = message.isInternal;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DisplayUser>, I>>(base?: I): DisplayUser {
    return DisplayUser.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DisplayUser>, I>>(object: I): DisplayUser {
    const message = createBaseDisplayUser();
    message.userId = object.userId ?? "";
    message.displayName = object.displayName ?? "";
    message.picture = object.picture ?? undefined;
    message.isInternal = object.isInternal ?? false;
    return message;
  },
};

function createBaseSavedVersionMetadata(): SavedVersionMetadata {
  return {
    versionId: "",
    user: undefined,
    clientVersionCreateTime: undefined,
    parentVersionId: undefined,
    revertVersionId: undefined,
    clientDeleteTime: undefined,
    deletedBy: undefined,
    activeTime: undefined,
  };
}

export const SavedVersionMetadata: MessageFns<SavedVersionMetadata> = {
  encode(message: SavedVersionMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.versionId !== "") {
      writer.uint32(10).string(message.versionId);
    }
    if (message.user !== undefined) {
      DisplayUser.encode(message.user, writer.uint32(18).fork()).join();
    }
    if (message.clientVersionCreateTime !== undefined) {
      Timestamp.encode(toTimestamp(message.clientVersionCreateTime), writer.uint32(26).fork()).join();
    }
    if (message.parentVersionId !== undefined) {
      writer.uint32(34).string(message.parentVersionId);
    }
    if (message.revertVersionId !== undefined) {
      writer.uint32(42).string(message.revertVersionId);
    }
    if (message.clientDeleteTime !== undefined) {
      Timestamp.encode(toTimestamp(message.clientDeleteTime), writer.uint32(50).fork()).join();
    }
    if (message.deletedBy !== undefined) {
      writer.uint32(58).string(message.deletedBy);
    }
    if (message.activeTime !== undefined) {
      Timestamp.encode(toTimestamp(message.activeTime), writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SavedVersionMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSavedVersionMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = DisplayUser.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.clientVersionCreateTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parentVersionId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.revertVersionId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.clientDeleteTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.deletedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.activeTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SavedVersionMetadata {
    return {
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
      user: isSet(object.user) ? DisplayUser.fromJSON(object.user) : undefined,
      clientVersionCreateTime: isSet(object.clientVersionCreateTime)
        ? globalThis.String(object.clientVersionCreateTime)
        : isSet(object.client_version_create_time)
        ? globalThis.String(object.client_version_create_time)
        : undefined,
      parentVersionId: isSet(object.parentVersionId)
        ? globalThis.String(object.parentVersionId)
        : isSet(object.parent_version_id)
        ? globalThis.String(object.parent_version_id)
        : undefined,
      revertVersionId: isSet(object.revertVersionId)
        ? globalThis.String(object.revertVersionId)
        : isSet(object.revert_version_id)
        ? globalThis.String(object.revert_version_id)
        : undefined,
      clientDeleteTime: isSet(object.clientDeleteTime)
        ? globalThis.String(object.clientDeleteTime)
        : isSet(object.client_delete_time)
        ? globalThis.String(object.client_delete_time)
        : undefined,
      deletedBy: isSet(object.deletedBy)
        ? globalThis.String(object.deletedBy)
        : isSet(object.deleted_by)
        ? globalThis.String(object.deleted_by)
        : undefined,
      activeTime: isSet(object.activeTime)
        ? globalThis.String(object.activeTime)
        : isSet(object.active_time)
        ? globalThis.String(object.active_time)
        : undefined,
    };
  },

  toJSON(message: SavedVersionMetadata): unknown {
    const obj: any = {};
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    if (message.user !== undefined) {
      obj.user = DisplayUser.toJSON(message.user);
    }
    if (message.clientVersionCreateTime !== undefined) {
      obj.clientVersionCreateTime = message.clientVersionCreateTime;
    }
    if (message.parentVersionId !== undefined) {
      obj.parentVersionId = message.parentVersionId;
    }
    if (message.revertVersionId !== undefined) {
      obj.revertVersionId = message.revertVersionId;
    }
    if (message.clientDeleteTime !== undefined) {
      obj.clientDeleteTime = message.clientDeleteTime;
    }
    if (message.deletedBy !== undefined) {
      obj.deletedBy = message.deletedBy;
    }
    if (message.activeTime !== undefined) {
      obj.activeTime = message.activeTime;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SavedVersionMetadata>, I>>(base?: I): SavedVersionMetadata {
    return SavedVersionMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SavedVersionMetadata>, I>>(object: I): SavedVersionMetadata {
    const message = createBaseSavedVersionMetadata();
    message.versionId = object.versionId ?? "";
    message.user = (object.user !== undefined && object.user !== null)
      ? DisplayUser.fromPartial(object.user)
      : undefined;
    message.clientVersionCreateTime = object.clientVersionCreateTime ?? undefined;
    message.parentVersionId = object.parentVersionId ?? undefined;
    message.revertVersionId = object.revertVersionId ?? undefined;
    message.clientDeleteTime = object.clientDeleteTime ?? undefined;
    message.deletedBy = object.deletedBy ?? undefined;
    message.activeTime = object.activeTime ?? undefined;
    return message;
  },
};

function createBaseListCategoryCollectionHistoryResponse(): ListCategoryCollectionHistoryResponse {
  return { pagination: undefined, versions: [] };
}

export const ListCategoryCollectionHistoryResponse: MessageFns<ListCategoryCollectionHistoryResponse> = {
  encode(message: ListCategoryCollectionHistoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(10).fork()).join();
    }
    for (const v of message.versions) {
      SavedVersionMetadata.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCategoryCollectionHistoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCategoryCollectionHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.versions.push(SavedVersionMetadata.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCategoryCollectionHistoryResponse {
    return {
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
      versions: globalThis.Array.isArray(object?.versions)
        ? object.versions.map((e: any) => SavedVersionMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListCategoryCollectionHistoryResponse): unknown {
    const obj: any = {};
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    if (message.versions?.length) {
      obj.versions = message.versions.map((e) => SavedVersionMetadata.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCategoryCollectionHistoryResponse>, I>>(
    base?: I,
  ): ListCategoryCollectionHistoryResponse {
    return ListCategoryCollectionHistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCategoryCollectionHistoryResponse>, I>>(
    object: I,
  ): ListCategoryCollectionHistoryResponse {
    const message = createBaseListCategoryCollectionHistoryResponse();
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    message.versions = object.versions?.map((e) => SavedVersionMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListCategoryHistoryResponse(): ListCategoryHistoryResponse {
  return { pagination: undefined, versions: [] };
}

export const ListCategoryHistoryResponse: MessageFns<ListCategoryHistoryResponse> = {
  encode(message: ListCategoryHistoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(10).fork()).join();
    }
    for (const v of message.versions) {
      SavedVersionMetadata.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCategoryHistoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCategoryHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.versions.push(SavedVersionMetadata.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCategoryHistoryResponse {
    return {
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
      versions: globalThis.Array.isArray(object?.versions)
        ? object.versions.map((e: any) => SavedVersionMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListCategoryHistoryResponse): unknown {
    const obj: any = {};
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    if (message.versions?.length) {
      obj.versions = message.versions.map((e) => SavedVersionMetadata.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCategoryHistoryResponse>, I>>(base?: I): ListCategoryHistoryResponse {
    return ListCategoryHistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCategoryHistoryResponse>, I>>(object: I): ListCategoryHistoryResponse {
    const message = createBaseListCategoryHistoryResponse();
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    message.versions = object.versions?.map((e) => SavedVersionMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseProfileListRequest(): ProfileListRequest {
  return {
    limit: undefined,
    olderCursor: undefined,
    search: undefined,
    inLibrary: undefined,
    carbon: undefined,
    customerUuid: undefined,
    includeCustomCategories: undefined,
  };
}

export const ProfileListRequest: MessageFns<ProfileListRequest> = {
  encode(message: ProfileListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.limit !== undefined) {
      writer.uint32(8).int64(message.limit);
    }
    if (message.olderCursor !== undefined) {
      writer.uint32(18).string(message.olderCursor);
    }
    if (message.search !== undefined) {
      writer.uint32(26).string(message.search);
    }
    if (message.inLibrary !== undefined) {
      writer.uint32(32).bool(message.inLibrary);
    }
    if (message.carbon !== undefined) {
      writer.uint32(40).bool(message.carbon);
    }
    if (message.customerUuid !== undefined) {
      writer.uint32(50).string(message.customerUuid);
    }
    if (message.includeCustomCategories !== undefined) {
      writer.uint32(56).bool(message.includeCustomCategories);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProfileListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProfileListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.limit = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.olderCursor = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.search = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.inLibrary = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.carbon = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.customerUuid = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.includeCustomCategories = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProfileListRequest {
    return {
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
      olderCursor: isSet(object.olderCursor)
        ? globalThis.String(object.olderCursor)
        : isSet(object.older_cursor)
        ? globalThis.String(object.older_cursor)
        : undefined,
      search: isSet(object.search) ? globalThis.String(object.search) : undefined,
      inLibrary: isSet(object.inLibrary)
        ? globalThis.Boolean(object.inLibrary)
        : isSet(object.in_library)
        ? globalThis.Boolean(object.in_library)
        : undefined,
      carbon: isSet(object.carbon) ? globalThis.Boolean(object.carbon) : undefined,
      customerUuid: isSet(object.customerUuid)
        ? globalThis.String(object.customerUuid)
        : isSet(object.customer_uuid)
        ? globalThis.String(object.customer_uuid)
        : undefined,
      includeCustomCategories: isSet(object.includeCustomCategories)
        ? globalThis.Boolean(object.includeCustomCategories)
        : isSet(object.include_custom_categories)
        ? globalThis.Boolean(object.include_custom_categories)
        : undefined,
    };
  },

  toJSON(message: ProfileListRequest): unknown {
    const obj: any = {};
    if (message.limit !== undefined) {
      obj.limit = Math.round(message.limit);
    }
    if (message.olderCursor !== undefined) {
      obj.olderCursor = message.olderCursor;
    }
    if (message.search !== undefined) {
      obj.search = message.search;
    }
    if (message.inLibrary !== undefined) {
      obj.inLibrary = message.inLibrary;
    }
    if (message.carbon !== undefined) {
      obj.carbon = message.carbon;
    }
    if (message.customerUuid !== undefined) {
      obj.customerUuid = message.customerUuid;
    }
    if (message.includeCustomCategories !== undefined) {
      obj.includeCustomCategories = message.includeCustomCategories;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProfileListRequest>, I>>(base?: I): ProfileListRequest {
    return ProfileListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProfileListRequest>, I>>(object: I): ProfileListRequest {
    const message = createBaseProfileListRequest();
    message.limit = object.limit ?? undefined;
    message.olderCursor = object.olderCursor ?? undefined;
    message.search = object.search ?? undefined;
    message.inLibrary = object.inLibrary ?? undefined;
    message.carbon = object.carbon ?? undefined;
    message.customerUuid = object.customerUuid ?? undefined;
    message.includeCustomCategories = object.includeCustomCategories ?? undefined;
    return message;
  },
};

function createBaseListCategoriesResponse(): ListCategoriesResponse {
  return { pagination: undefined, categories: [] };
}

export const ListCategoriesResponse: MessageFns<ListCategoriesResponse> = {
  encode(message: ListCategoriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(10).fork()).join();
    }
    for (const v of message.categories) {
      SavedLibraryCategory.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCategoriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCategoriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.categories.push(SavedLibraryCategory.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCategoriesResponse {
    return {
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => SavedLibraryCategory.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListCategoriesResponse): unknown {
    const obj: any = {};
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    if (message.categories?.length) {
      obj.categories = message.categories.map((e) => SavedLibraryCategory.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCategoriesResponse>, I>>(base?: I): ListCategoriesResponse {
    return ListCategoriesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCategoriesResponse>, I>>(object: I): ListCategoriesResponse {
    const message = createBaseListCategoriesResponse();
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    message.categories = object.categories?.map((e) => SavedLibraryCategory.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSavedLibraryMetadata(): SavedLibraryMetadata {
  return { addedTime: undefined, addedBy: undefined };
}

export const SavedLibraryMetadata: MessageFns<SavedLibraryMetadata> = {
  encode(message: SavedLibraryMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.addedTime !== undefined) {
      Timestamp.encode(toTimestamp(message.addedTime), writer.uint32(10).fork()).join();
    }
    if (message.addedBy !== undefined) {
      DisplayUser.encode(message.addedBy, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SavedLibraryMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSavedLibraryMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.addedTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.addedBy = DisplayUser.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SavedLibraryMetadata {
    return {
      addedTime: isSet(object.addedTime)
        ? globalThis.String(object.addedTime)
        : isSet(object.added_time)
        ? globalThis.String(object.added_time)
        : undefined,
      addedBy: isSet(object.addedBy)
        ? DisplayUser.fromJSON(object.addedBy)
        : isSet(object.added_by)
        ? DisplayUser.fromJSON(object.added_by)
        : undefined,
    };
  },

  toJSON(message: SavedLibraryMetadata): unknown {
    const obj: any = {};
    if (message.addedTime !== undefined) {
      obj.addedTime = message.addedTime;
    }
    if (message.addedBy !== undefined) {
      obj.addedBy = DisplayUser.toJSON(message.addedBy);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SavedLibraryMetadata>, I>>(base?: I): SavedLibraryMetadata {
    return SavedLibraryMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SavedLibraryMetadata>, I>>(object: I): SavedLibraryMetadata {
    const message = createBaseSavedLibraryMetadata();
    message.addedTime = object.addedTime ?? undefined;
    message.addedBy = (object.addedBy !== undefined && object.addedBy !== null)
      ? DisplayUser.fromPartial(object.addedBy)
      : undefined;
    return message;
  },
};

function createBaseSavedLibraryCategory(): SavedLibraryCategory {
  return { metadata: undefined, category: undefined, libraryMetadata: undefined };
}

export const SavedLibraryCategory: MessageFns<SavedLibraryCategory> = {
  encode(message: SavedLibraryCategory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      SavedVersionMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.category !== undefined) {
      Category1.encode(message.category, writer.uint32(18).fork()).join();
    }
    if (message.libraryMetadata !== undefined) {
      SavedLibraryMetadata.encode(message.libraryMetadata, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SavedLibraryCategory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSavedLibraryCategory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = SavedVersionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.category = Category1.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.libraryMetadata = SavedLibraryMetadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SavedLibraryCategory {
    return {
      metadata: isSet(object.metadata) ? SavedVersionMetadata.fromJSON(object.metadata) : undefined,
      category: isSet(object.category) ? Category1.fromJSON(object.category) : undefined,
      libraryMetadata: isSet(object.libraryMetadata)
        ? SavedLibraryMetadata.fromJSON(object.libraryMetadata)
        : isSet(object.library_metadata)
        ? SavedLibraryMetadata.fromJSON(object.library_metadata)
        : undefined,
    };
  },

  toJSON(message: SavedLibraryCategory): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = SavedVersionMetadata.toJSON(message.metadata);
    }
    if (message.category !== undefined) {
      obj.category = Category1.toJSON(message.category);
    }
    if (message.libraryMetadata !== undefined) {
      obj.libraryMetadata = SavedLibraryMetadata.toJSON(message.libraryMetadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SavedLibraryCategory>, I>>(base?: I): SavedLibraryCategory {
    return SavedLibraryCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SavedLibraryCategory>, I>>(object: I): SavedLibraryCategory {
    const message = createBaseSavedLibraryCategory();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? SavedVersionMetadata.fromPartial(object.metadata)
      : undefined;
    message.category = (object.category !== undefined && object.category !== null)
      ? Category1.fromPartial(object.category)
      : undefined;
    message.libraryMetadata = (object.libraryMetadata !== undefined && object.libraryMetadata !== null)
      ? SavedLibraryMetadata.fromPartial(object.libraryMetadata)
      : undefined;
    return message;
  },
};

function createBaseSavedPlantProfile(): SavedPlantProfile {
  return { metadata: undefined, profile: undefined };
}

export const SavedPlantProfile: MessageFns<SavedPlantProfile> = {
  encode(message: SavedPlantProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      SavedVersionMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.profile !== undefined) {
      PlantProfile.encode(message.profile, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SavedPlantProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSavedPlantProfile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = SavedVersionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.profile = PlantProfile.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SavedPlantProfile {
    return {
      metadata: isSet(object.metadata) ? SavedVersionMetadata.fromJSON(object.metadata) : undefined,
      profile: isSet(object.profile) ? PlantProfile.fromJSON(object.profile) : undefined,
    };
  },

  toJSON(message: SavedPlantProfile): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = SavedVersionMetadata.toJSON(message.metadata);
    }
    if (message.profile !== undefined) {
      obj.profile = PlantProfile.toJSON(message.profile);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SavedPlantProfile>, I>>(base?: I): SavedPlantProfile {
    return SavedPlantProfile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SavedPlantProfile>, I>>(object: I): SavedPlantProfile {
    const message = createBaseSavedPlantProfile();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? SavedVersionMetadata.fromPartial(object.metadata)
      : undefined;
    message.profile = (object.profile !== undefined && object.profile !== null)
      ? PlantProfile.fromPartial(object.profile)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
